export const projects = [
  {
    id: 1,
    title: "Broker Review Platform",
    url: "https://brokerreviewers.com",
    description:
      "Scalable broker review platform with authentication, user profiles, moderation workflows, and dynamic broker data handling.",
    role: "Full-stack development, custom WordPress plugin development, API integrations, performance optimization",
    tech: ["WordPress", "PHP", "MySQL", "JavaScript", "APIs"],
    highlights: [
      "Built authentication, user profiles, and moderation workflows",
      "Developed custom WordPress plugins for platform-specific functionality",
      "Integrated APIs for dynamic broker data and business logic",
      "Improved performance, scalability, and SEO",
    ],
    featured: true,
  },
  {
    id: 2,
    title: "EasyFlow",
    url: "https://easyflow.co.uk/",
    description:
      "Workflow automation platform for streamlining business processes.",
    role: "Full-stack development, API integrations, performance optimization",
    tech: ["WordPress", "PHP", "JavaScript", "APIs"],
    highlights: [
      "Built scalable workflow automation features",
      "Integrated third-party services",
      "Improved performance and responsiveness",
    ],
  },
  {
    id: 3,
    title: "Accelagen",
    url: "https://www.accelagen.com.au/",
    description:
      "Business website focused on digital and enterprise services.",
    role: "Frontend and backend development, SEO optimization",
    tech: ["WordPress", "PHP", "HTML", "CSS", "JavaScript"],
    highlights: [
      "Improved SEO and Core Web Vitals",
      "Built responsive UI",
      "Optimized loading speed",
    ],
  },
  {
    id: 4,
    title: "SmartPing AI",
    url: "https://smartping.ai/",
    description:
      "AI-powered platform for smart communication and automation.",
    role: "Backend development, API integration, AI features",
    tech: ["PHP", "APIs", "AI Integration"],
    highlights: [
      "Integrated AI-based workflows",
      "Developed dynamic backend logic",
      "Enhanced scalability",
    ],
  },
  {
    id: 5,
    title: "Exponentially App",
    url: "https://app.exponentially.com/",
    description:
      "Web application platform for business growth and analytics.",
    role: "Backend development and system architecture",
    tech: ["Laravel", "PHP", "MySQL", "APIs"],
    highlights: [
      "Built scalable backend modules",
      "Implemented secure data handling",
      "Integrated multiple APIs",
    ],
  },
  {
    id: 6,
    title: "LegaTax",
    url: "https://legatax.in/",
    description: "Professional tax and financial services platform.",
    role: "WordPress development and customization",
    tech: ["WordPress", "PHP", "JavaScript"],
    highlights: [
      "Developed custom UI components",
      "Improved SEO performance",
      "Optimized site speed",
    ],
  },
  {
    id: 7,
    title: "KC Matches",
    url: "https://kcmatches.com/",
    description: "Matchmaking platform with user interaction features.",
    role: "Full-stack development and user system implementation",
    tech: ["PHP", "MySQL", "JavaScript"],
    highlights: [
      "Built user profiles and interaction system",
      "Developed backend logic",
      "Designed database structure",
    ],
  },
  {
    id: 8,
    title: "Landmark Markets",
    url: "https://landmarkmarkets.com/",
    description:
      "Financial services platform featuring real-time stock market data integration, multiple dynamic display formats, and a user-driven review and rating system — built to deliver institutional-grade market visibility with an intuitive frontend experience.",
    role: "Custom WordPress plugin architecture, stock market API integration, dynamic UI development, review and rating system engineering",
    tech: ["WordPress", "PHP", "JavaScript", "APIs", "Custom Plugin Development"],
    highlights: [
      "Developed a custom WordPress plugin to fetch, process, and display live stock market data via external APIs",
      "Built multiple presentation layouts — data tables, live tickers, and interactive graph-based views — tailored to different user contexts",
      "Engineered a review and rating system powered by WPForms submissions with dynamic rating calculation based on aggregated user feedback",
    ],
  },
  {
    id: 9,
    title: "eMenu Order System",
    url: "https://emenuorder.com/TestOrder_PHP8_V2/",
    description:
      "Online food ordering system with dynamic menu and ordering flow.",
    role: "Backend development and system logic",
    tech: ["PHP", "MySQL", "AJAX"],
    highlights: [
      "Built dynamic menu system",
      "Implemented ordering workflow",
      "Enabled real-time updates",
    ],
  },
];
